<template>
    <button
        :class="classObject"
        type="button"
        :aria-label="label"
        :aria-expanded="toggleState ? 'true' : 'false'"
        @click="onclick"
    >
        <span class="lines"></span>
    </button>
</template>

<script>
export default {
    name: 'nav-toggler',
    computed: {
        classObject() {
            if (this.menuExpanded) {
                return [
                    'lines-button',
                    'navbar-toggler',
                    'navbar-toggler-' + this.position,
                    'close'
                ]
            } else {
                return [
                    'lines-button',
                    'navbar-toggler',
                    'navbar-toggler-' + this.position
                ]
            }
        }
    },
    data() {
        return {
            toggleState: false
        }
    },
    props: {
        label: {
            type: String,
            default: 'Toggle navigation'
        },
        menuExpanded: false,
        position: {
            type: String,
            default: 'right'
        }
    },
    methods: {
        onclick() {
            this.$emit('click')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../styles/main.scss';
@import '../../styles/toggler.scss'; // http://www.sarasoueidan.com/blog/navicon-transformicons/
</style>



// WEBPACK FOOTER //
// src/components/menu/NavToggleComponent.vue